export default __webpack_public_path__ + "static/media/EmptyLineGraph.787aefbd.svg";